import { getBoundaryColourByLevel } from '@/helpers/colour';

const formatter = 'timeseries';

/**
 * Format result data that is in a timeseries format (resultData will be an array)
 *
 * @param {Kpi} kpi
 * @param {Array} resultData
 */
export default function formatTimeseries(kpi, resultData) {
  const displayType = kpi.getDisplayType();
  const displayData = {
    key: 'Data 1',
    type: displayType,
    values: [],
  };

  const { data, meta: { typeY0 } } = resultData;
  const { displayOptions: { displayBoundaries, hideLineMarkers } } = kpi;

  const displayColours = displayType !== 'line'
    && ((typeY0 === 'percentage' && displayBoundaries === undefined)
      || displayBoundaries === true);

  if (displayType === 'line') {
    displayData.mode = hideLineMarkers ? 'lines' : 'lines+markers';
  }

  const points = data.map(({ x, y0, level0 }) => ({
    x: new Date(x),
    y: typeY0 === 'percentage' ? y0 / 100 : y0,
    colour: level0 && displayColours
      ? getBoundaryColourByLevel(level0)
      : undefined,
  }));

  displayData.values = points;
  return {
    displayType,
    displayData,
    isPercent: kpi.isPercent(),
    formatter,
  };
}
